'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBinoculars = function FaBinoculars(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.7 7.1v17.2q0 0.6-0.4 1t-1 0.4v12.9q0 0.5-0.4 1t-1 0.4h-11.5q-0.6 0-1-0.4t-0.4-1v-11.5l5.6-19.4q0.1-0.6 0.7-0.6h9.4z m7.2 0v15.8h-5.8v-15.8h5.8z m17.1 20v11.5q0 0.6-0.4 1t-1 0.4h-11.5q-0.5 0-1-0.4t-0.4-1v-12.9q-0.6 0-1-0.4t-0.4-1v-17.2h9.5q0.5 0 0.6 0.6z m-23.6-26.4v5h-7.8v-5q0-0.3 0.2-0.5t0.5-0.2h6.4q0.3 0 0.5 0.2t0.2 0.5z m15 0v5h-7.8v-5q0-0.3 0.2-0.5t0.5-0.2h6.4q0.3 0 0.5 0.2t0.2 0.5z' })
        )
    );
};

exports.default = FaBinoculars;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/binoculars.js
// module id = 104
// module chunks = 58411574672382 79611799117203 84521481881339 164655002686464